import { Box, Container,  Typography, Tab,  Button, MenuItem, Menu } from '@mui/material'
import React, { useState, useEffect } from 'react'
import {BsSearch, BsFillMoonStarsFill} from 'react-icons/bs';
import {RiVisaLine} from 'react-icons/ri';
import {GiStarsStack} from 'react-icons/gi';
import {SiYourtraveldottv} from 'react-icons/si';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import './holidaymob.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useUserAuth } from '../login/userAuthContext';
import { useNavigate } from 'react-router';
import CityMenu from '../dropdowns/dropdownCity';

const months = ["Jan'", "Feb'", "Mar'", "April", "May", "June", "July", "Aug'", "Sept'", "Oct'", "Nov'", "Dec'"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const saerchBtnStyle = {
  fontSize: '14px',
  borderRadius: '30px',
  width: '100px',
  marginTop:'20px',
  marginBottom:'20px'
}
const numberArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export default function HolidayMobile() {
  const [date, setDate] = useState();
  const [userDate, setUserDate] = useState(new Date());
  const {user} = useUserAuth();
  const [city, setCity] = useState("Delhi");
  const [cityClicked, setCityClicked] = useState(true);
  const [city2, setCity2] = useState("Goa");
  const [destClicked, setDestClicked] = useState(true);
  useEffect(()=>{
    setUserDate(new Date(date));
  }, [date])
const navbar2= {
    width: '80vw',
    height:'30px',
    backgroundColor: 'white',
    display:'block',
    margin: '10px auto',
}
const texter2 = {
    textTransform: "none",
    fontSize: '12px',
    fontWeight:'bold',
    paddingTop: '5px',
    width:'5vw',
    display:'flex',
    borderLeft:'2px solid #bbb',
    backgroundColor:'rgba(194, 239, 254,0.5)'
}

function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
        }}
        {...props}
      />
    );
  }
  
function Appbar() {
    const [valueNav, setValueNav] = useState("search");
    const handleChange2 = (event, newValue)=> {
        setValueNav(newValue);
        event.stopPropagation();
    }
    const widthClass2 = {
        width: '100vw',
        display:'flex',
        justifyContent:'center',
        alignItems: 'center'
    }
    return (
        <div style={widthClass2}>
            <Container
            sx={{paddingLeft:'10px'}}
        >
        <TabContext value={valueNav} sx={navbar2}>
        <Box 
        display='flex'
        sx={{ borderBottom: 1, borderColor:'white', width:"100vw"}}>
            <TabList onChange={handleChange2}
            sx={{width: '100vw',  justifyContent:'space-evenly'}}
            >
                <LinkTab sx={texter2} icon={<BsSearch style={{fontSize:"12px"}}/>} label="Search" value="search"/>
                <LinkTab sx={texter2} icon={<RiVisaLine style={{fontSize:"12px"}}/>} label="Easy Visa Destination" value="visa" />
                <LinkTab sx={texter2} icon={<BsFillMoonStarsFill style={{fontSize:"12px"}}/>} label="Honeymoon" value="home" />
                <LinkTab sx={texter2} icon={<GiStarsStack style={{fontSize:"12px"}}/>} label="New Arrival" value="train" />
            </TabList>
        </Box>
        </TabContext>
        </Container>
        </div>
  )
}
    function LocationCard(props){
      const handleLocation = ()=> {
        if(props.firstLine==="From City"){
          setCityClicked(true);
        }else{
          setDestClicked(true);
        }
      }
        return(
            <div className='holiday-mobile' onMouseOver={handleLocation}>
                <Typography variant='body2' fontWeight='bold' sx={{fontFamily:'Poppins'}} onMouseOver={handleLocation}>{props.firstLine}</Typography>
                <Typography variant='h1' fontSize='40px' sx={{fontFamily:'Poppins'}} onMouseOver={handleLocation}>{props.selectCity}</Typography>
                <Typography variant='body2' fontWeight='bold' sx={{fontFamily:'Poppins'}} onMouseOver={handleLocation}>{props.country}</Typography>
            </div> 
        )
    }
    function TravellerCount(props){
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
      const handleSelectTag = ()=>{
        setAnchorEl(null);
      }
      return (
        <div className='holiday-mobile'>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{textTransform:'none', textAlign:'left'}}
          >
            {props.guest}
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem>
              <div className='traveller-apartHoliday'>
                <h3>{props.select1}</h3>
                <div>
                  <select onSelect={handleSelectTag}>
                    {numberArray.map(el=>{
                      return <option key={el}>{el}</option>
                    })}
                  </select>
                </div>
              </div>
            </MenuItem>
            <MenuItem>
            <div className='traveller-apartHoliday'>
                <h3>{props.select2}</h3>
                <div>
                  <select onSelect={handleSelectTag}>
                    {numberArray.map(el=>{
                      return <option key={el}>{el}</option>
                    })}
                  </select>
                </div>
              </div>
            </MenuItem>
          </Menu>
          <div style={{display:'flex'}}><h4>Select Rooms</h4></div>
        </div>
      );
    }
    function UtilityCard(props){
        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);
        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
            setAnchorEl(null);
        };
        useEffect(()=>{
          setAnchorEl(null);
      }, [date]);
      
        const handleDateChange = (e)=>{
          setDate(e.target.value);
        }
        
        return (
        <div style={{textAlign:'left'}}>
        <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none'}}
      >
        {props.options}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem><input type='date' onChange={handleDateChange}/></MenuItem>
      </Menu>
    </div>
    )
    }
    function DateCard(props){
        return (
          <div className='holiday-mobile'>
            <UtilityCard options={props.options} />

            {date ? <div>
            <Box display='flex'>
            <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{userDate.getDate()}</Typography>
            <Typography variant='h3' fontSize='23px'>{months[userDate.getMonth()]}</Typography>
            <Typography variant='h3' fontSize='23px'>{userDate.getFullYear()}</Typography>
            </Box>
            <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[userDate.getDay()]}</Typography>
            </div> : 
            <div>
            <Box display='flex'>
            <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{new Date().getDate()}</Typography>
            <Typography variant='h3' fontSize='23px'>{months[new Date().getMonth()]}</Typography>
            <Typography variant='h3' fontSize='23px'>{new Date().getFullYear()}</Typography>
            </Box>
            <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
            </div>
          }
          </div>

        )
    }
    const navigate = useNavigate();
    const handleTickets = ()=> {
      if(user){
        navigate('/tickets/holiday');
      }else{
        navigate('/login');
      }
    }
  return (
    <div className='holidayMob' onClick={()=>setCityClicked(true)}>
     <div><Appbar /></div>
     <div>
     <div>
           <Box 
           display='flex'
           sx={{flexDirection:'column'}}
           >
            <Container><LocationCard firstLine={"To City/Country/Category"} selectCity={city} /></Container>
            <Container >{cityClicked && <div className='city1'><CityMenu setterFunc={setCity} removeMenu={setCityClicked}/></div>}</Container>
            <Container><LocationCard firstLine={"To City/Country/Category"} selectCity={city2} /></Container>
            <Container>{destClicked && <div className='city2'><CityMenu setterFunc={setCity2} removeMenu={setDestClicked} /></div>}</Container>
            <Container><DateCard options={'Departure Date'} enter={true} /></Container>
            <Container> <TravellerCount guest={"Rooms & Guest"} select1={"Adults"} select2 = {"Rooms"} /></Container>
           </Box>
        </div>
     </div>
     <Container><Button variant='contained' sx={saerchBtnStyle} onClick={handleTickets}>SEARCH</Button></Container>
    
    </div>
  )
}
